/**
 * The customer's Orders tab has two views: the list of orders in One, and All history (orders in One and Tharstern work in one
 * list, v1 completion F5). Both pages show this switch, with their own view current.
 */
import { Link } from "react-router";
import { paths } from "@shared-core/routing/routes";

const chipClass =
  "rounded-full border px-3 py-1 text-sm hover:bg-muted aria-[current=page]:border-[color:var(--color-primary)] aria-[current=page]:bg-muted aria-[current=page]:font-medium";

export function CustomerOrdersViewSwitch({
  customerId,
  current,
}: {
  customerId: string;
  current: "orders" | "history";
}) {
  return (
    <nav aria-label="Orders view" className="flex gap-2">
      <Link
        to={paths.customerOrders({ customerId })}
        aria-current={current === "orders" ? "page" : undefined}
        className={chipClass}
      >
        Orders in One
      </Link>
      <Link
        to={paths.customerOrderHistory({ customerId })}
        aria-current={current === "history" ? "page" : undefined}
        className={chipClass}
      >
        All history
      </Link>
    </nav>
  );
}
